<template>
    <div class="orderparticulars">
        <div class="orderparticulars-box">
            <div class="charter-nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/persondata' }">个人中心首页</el-breadcrumb-item>
                    <el-breadcrumb-item>包车订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="orderparticulars-all">
                <div class="orderparticulars-status">
                    <div class="orderparticulars-status-left">
                        <p class="order-number-title">
                            订单号：20210605090206
                        </p>
                        <p class="order-status">
                            待出行
                        </p>
                        <div class="order-number-bottom">
                            <div class="order-number-bottom-box">
                                <img :src="iconOne" alt="">
                                <span>申请发票</span>
                            </div>
                            <div class="order-number-bottom-box">
                                <img :src="iconTwo" alt="">
                                <span>申请发票</span>
                            </div>
                        </div>
                    </div>
                    <div class="orderparticulars-status-right">
                        <div class="step-top">
                            <div class="step-list-img">
                                <img :src="stepOne" alt="">
                                <span class="step-list-text">提交订单</span>
                                <p class="step-list-time">
                                    2021-06-05 09:49:44
                                </p>
                            </div>
                            <img class="step-list-icon" :src="rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="stepTwo" alt="">
                                <span class="step-list-text">付款成功</span>
                                <p class="step-list-time">
                                    2021-06-05 09:49:44
                                </p>
                            </div>
                            <img class="step-list-icon" :src="rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="stepThree" alt="">
                                <span class="step-list-text">等待出行</span>
                                <p class="step-list-time">
                                    2021-06-05 09:49:44
                                </p>
                            </div>
                            <img class="step-list-icon" :src="rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="stepFour" alt="">
                                <span class="step-list-text">出行中</span>
                                <p class="step-list-time">
                                    2021-06-05 09:49:44
                                </p>
                            </div>
                            <img class="step-list-icon" :src="rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="stepFive" alt="">
                                <span class="step-list-text">完成</span>
                                <p class="step-list-time">
                                    2021-06-05 09:49:44
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="orderparticulars-info">
                    <p class="info-title">
                        联系人信息
                    </p>
                    <div class="info-detail">
                        <div class="info-detail-left">
                            <span class="info-detail-left-tit">· 姓名：</span>
                            <span class="info-detail-left-name">张三</span>
                        </div>
                        <div class="info-detail-right">
                            <span class="info-detail-left-tit">· 手机号：</span>
                            <span class="info-detail-left-name">17350811083</span>
                        </div>
                    </div>
                </div>
                <div class="orderparticulars-trip">
                    <div class="trip-left">
                        <div class="trip-title">行程信息</div>
                        <div class="trip-detail">
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 包车类型：</div>
                                <div class="trip-detail-row-content">市内包车</div>
                            </div>

                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 出发地点：</div>
                                <div class="trip-detail-row-content">厦门市集美区软件园三期石秀才大厦</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 途径地点：</div>
                                <div class="trip-detail-row-content">无</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 目的地点：</div>
                                <div class="trip-detail-row-content">福州市仓山区坚信真津塘路31号综合楼大厦边上的一家小卖部的左边十步右边五十步</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 出发时间：</div>
                                <div class="trip-detail-row-content">2021-06-05 10:07</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 总公里数：</div>
                                <div class="trip-detail-row-content">2021km</div>
                            </div>
                        </div>
                    </div>
                    <div class="trip-right">
                        <div class="trip-right-car">
                            <div class="trip-title">已选车辆</div>
                            <div class="trip-right-car-choose">
                                <div class="car-choose-info">
                                    <span class="car-choose-info-name">江海瑞风</span>
                                    <span class="car-choose-info-seat">9座</span>
                                    <span class="car-choose-info-num">14辆</span>
                                    <span class="car-choose-info-money">¥ 20000.3</span>
                                </div>
                                <div class="car-choose-info">
                                    <span class="car-choose-info-name">江海瑞风</span>
                                    <span class="car-choose-info-seat">9座</span>
                                    <span class="car-choose-info-num">14辆</span>
                                    <span class="car-choose-info-money">¥ 20000.3</span>
                                </div>
                            </div>
                        </div>
                        <div class="trip-right-team">
                            <div class="trip-title">已选车队</div>
                            <div class="trip-right-car-choose">
                                <div class="car-choose-team-name">
                                    皇包车(厦门)科技有限集团
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="orderparticulars-money">
                    <div class="order-money-box">
                        <div class="order-money-box-top">
                            <span class="order-money-text">
                                订单金额：
                            </span>
                            <span class="order-money-number">
                                ¥ 21502525.02
                            </span>
                        </div>
                        <div class="order-money-box-top-red">
                            <span class="order-money-text-red">
                                订单金额：
                            </span>
                            <span class="order-money-number-red">
                                ¥ 21502525.02
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <home-footer></home-footer>
    </div>
</template>

<script>
    import HomeFooter from '@/components/homeFooter';
    export default {
        name: "orderparticulars",
        components: {
            HomeFooter
        },
        data() {
            return {
                orderid: '',
                iconOne: require('@/assets/images/persondata/personal_icon_fapiao.png'),
                iconTwo: require('@/assets/images/persondata/personal_icon_quxiao.png'),

                stepList: [
                    {
                        text: '提交订单',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '付款成功',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '等待出行',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '出行中',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '完成',
                        time: '2021-06-05 09:49:44'
                    },

                ],

                hasIcon: true,
                rightIcon: require('@/assets/images/persondata/personal_icon_ddbzh00.png'),
                rightIconPre: require('@/assets/images/persondata/personal_icon_ddbzh00_pre.png'),

                stepOne: require('@/assets/images/persondata/personal_icon_ddbzh01.png'),
                stepTwo: require('@/assets/images/persondata/personal_icon_ddbzh02.png'),
                stepThree: require('@/assets/images/persondata/personal_icon_ddbzh03.png'),
                stepFour: require('@/assets/images/persondata/personal_icon_ddbzh04.png'),
                stepFive: require('@/assets/images/persondata/personal_icon_ddbzh05.png'),
            }
        },
        created() {
            this.orderid = this.$route.params.orderId;
        }
    }
</script>

<style scoped>
    .orderparticulars {
        width: 100%;
        min-width: 1200px;
        margin: 0 auto;
        background: #F5F5F5;
        border-top: 2px solid #FF5227;
    }

    .orderparticulars-box {
        width: 1200px;
        margin: 0 auto;
    }

    .charter-nav {
        width: 1200px;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 auto;
    }

    .charter-nav >>> .el-breadcrumb__inner a, .charter-nav >>> .el-breadcrumb__inner.is-link {
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
    }

    .orderparticulars-all {
        width: 1200px;
        margin: 0 auto 30px;
    }

    .orderparticulars-status {
        width: 1200px;
        height: 210px;
        background: #FFFFFF;
        border-top: 2px solid #FA592A;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .orderparticulars-status-left {
        width: 400px;
        height: 150px;
        border-right: 1px solid #eee;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .order-number-title {
        width: 300px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #535353;
        font-size: 14px;
        margin-top: 10px;
    }

    .order-status {
        width: 300px;
        height: 40px;
        line-height: 40px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FA592A;
        text-align: center;
        margin: 10px 0 10px 0;
    }

    .order-number-bottom {
        width: 210px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 20px auto 0;
    }

    .order-number-bottom-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .order-number-bottom-box img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .order-number-bottom-box span {
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #535353;
    }

    .orderparticulars-status-right {
        width: 760px;
        height: 150px;
        margin-left: 30px;
        display: flex;
        flex-direction: row;
    }

    .step-top {
        margin-top: 27px;
        width: 760px;
        display: flex;
        flex-direction: row;
    }

    .step-list-icon {
        width: 66px;
        height: 8px;
        margin: 14px -8px 0;
    }

    .step-list-img {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .step-list-img img {
        width: 28px;
        height: 28px;
    }

    .step-list-text {
        width: 80px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin: 16px 0 0 0;
    }

    .step-list-time {
        width: 100px;
        line-height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
        margin-top: 12px;
    }

    .orderparticulars-info {
        width: 1200px;
        height: 120px;
        background: #FFFFFF;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
    }

    .info-title {
        width: 100px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-left: 30px;
        margin-top: 26px;
    }

    .info-detail {
        margin-top: 26px;
        margin-left: 26px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-detail-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 60px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .orderparticulars-trip {
        width: 1200px;
        height: 337px;
        background: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .trip-left {
        margin-left: 30px;
        margin-top: 20px;
        width: 650px;
        height: 295px;
        border-right: 1px solid #EEEEEE;
        display: flex;
        flex-direction: column;
    }

    .trip-title {
        width: 120px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
    }

    .trip-detail {
        margin-top: 26px;
    }

    .trip-detail-row {
        display: flex;
        flex-direction: row;
        min-height: 20px;
        margin: 6px 0;
    }

    .trip-detail-row-tit {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
    }

    .trip-detail-row-content {
        max-width: 500px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
    }

    .trip-right {
        margin-top: 20px;
        width: 490px;
        height: 295px;
    }

    .trip-right-car {
        height: 140px;
        overflow: hidden;
    }

    .trip-right-car-choose {
        margin: 10px 0 0 0;
    }

    .car-choose-info {
        display: flex;
        flex-direction: row;
        align-items: center;

        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .car-choose-info-name {
        width: 100px;
        height: 24px;
        line-height: 24px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .car-choose-info-seat {
        height: 24px;
        line-height: 24px;
        margin-right: 30px;
    }

    .car-choose-info-num {
        height: 24px;
        line-height: 24px;
        margin-right: 30px;
    }

    .car-choose-info-money {
        height: 24px;
        line-height: 24px;
    }

    .trip-right-team {
        height: 140px;
    }

    .car-choose-team-name {
        height: 24px;
        line-height: 24px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .orderparticulars-money {
        width: 1200px;
        height: 110px;
        background: #E9E9E9;
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    .order-money-box {
        width: 260px;
        height: 70px;
        margin-right: 30px;
    }

    .order-money-box-top {
        width: 260px;
        height: 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }

    .order-money-box-top-red {
        width: 260px;
        height: 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .order-money-text, .order-money-number {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .order-money-text-red{
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #CF0000;
    }
    .order-money-number-red {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #CF0000;
    }
</style>


// WEBPACK FOOTER //
// src/pages/persondata/children/orderparticulars.vue